import { Sede } from 'src/app/Admin/models/Sede';
import { Persona } from '../../Admin/models/persona';
import { Azienda } from '../../Admin/models/Azienda';
import { VoceProgetto } from "./VoceProgetto";
import {Files} from "../../shared/models/File";
import {Blocco} from "../../blocchi/_Models/blocco";
import {ClassicType} from "../../shared/models/ClassicType";
import {CampoAggiuntivo} from "../../shared/models/campo-aggiuntivo";
import {ProvaAcquisto} from "../../rma/_Models/prova-acquisto";
import {environment} from "../../../environments/environment";

export class Progetto {
  id: number;
  cliente: number;
  clienteObject: Azienda;
  manager: number; // id del commerciale
  managerObject: Persona;
  codice: string;
  oggetto: string;
  colore: string; // codice esadecimale del colore
  note: string;
  note_private: string;
  voci: VoceProgetto[];
  data_creazione: string; // data modificabile
  data_emissione: string; // data di emissione del preventivo
  data_accettazione: string; // data di accettazione del preventivo
  data_conferma: string; // data di conferma del preventivo
  enabled: boolean;
  progetti: Progetto[];
  sede_id?: number = null;
  sedeObject?: Sede;
  sediObject?: Sede[];
  files?: Files[];
  stato: string;
  consegna: Azienda;
  commerciale?: Persona;
  segnalatore?: Azienda;
  id_segnalatore?: number;
  id_commerciale?: number;
  lavorato?: boolean;
  blocchi?: Blocco[];
  gestore?: number ;
  gestoreObject?:Persona;
  costoSpedizione?: number;
  pagato?: boolean;
  gestoreNome?: string;
  rev?: any;
  pagamentoObject?: ClassicType;
  pagamento?:number;
  francoDeposito?: boolean;
  referente?: Azienda;
  attivita?: { check?: string; id?: number; risposta?: boolean; fields?: CampoAggiuntivo[] }[];
  provaAcquisto?: any;
  prezzo?: number;
  codiceContratto?: string;
  proveAcquisto?: ProvaAcquisto[] ;
  hide?: boolean;
  bancaObject?: any;
  banca?: number;
  agenteObject?: any;
  codiceOrdine?: string;
  checkAmm?: boolean;
  SommaImportiFase?:number;

  constructor() {
    this.voci = [];
    this.progetti = [];
    this.blocchi = [];
    this.sede_id = null;
    this.note = "";
    this.note_private = "";
    this.data_creazione = new Date().toISOString();
    this.consegna  = new Azienda();
    this.referente = new Azienda();
    this.pagato = false;
  }
  public static IsPreventivo(progetto): boolean{
    return environment.ProgettiAddon['CampiSottoOffertaPreventivo'] && !progetto.codiceContratto && !progetto.data_conferma;
  }
}
